import React from 'react';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';
import {
  CloseButton,
  ResidenceGalleryHeaderContainer,
  GalleryInfo,
  GalleryHeaderContent,
  ContentText,
  Divider,
  BuildingInfoText,
  PhoneWrapper,
  LeftActionsContainer
} from './styled';
import Icon from '../../../Icon';
import CloseIcon from '../../../../public/static/images/close-modal.svg';
import { BottomPhoneButton } from '../../BottomPhoneButton';

interface ResidenceGalleryHeaderProps {
  galleryDescription: string;
  priceInfo: string;
  showPhoneButton?: boolean;
  phones?: string[] | null;
  pageNumber?: number;
  photosLength?: number;
  onClickHandler?: PhoneButtonClickHandler;
  onClose: () => void;
}

export const ResidenceGalleryHeader: React.FC<ResidenceGalleryHeaderProps> = ({
  galleryDescription,
  priceInfo,
  showPhoneButton = true,
  phones,
  pageNumber,
  photosLength,
  onClickHandler,
  onClose
}) => {
  return (
    <ResidenceGalleryHeaderContainer>
      <GalleryHeaderContent>
        <ContentText tag="title_3_new">{galleryDescription}</ContentText>
        <Divider />
        <BuildingInfoText tag="title_3_new">{priceInfo}</BuildingInfoText>
      </GalleryHeaderContent>
      <LeftActionsContainer>
        {showPhoneButton && onClickHandler && (
          <PhoneWrapper>
            <BottomPhoneButton
              stat="product-call-btn"
              isGallery
              isIconButton
              clickHandler={onClickHandler}
              phones={phones}
            />
          </PhoneWrapper>
        )}
        <CloseButton
          role="button"
          tabIndex={-1}
          onClick={onClose}
          onKeyPress={onClose}
          data-cy="gallery-close-button"
        >
          <Icon
            IconComponent={CloseIcon}
            height={15}
            width={15}
            indent={false}
          />
        </CloseButton>
      </LeftActionsContainer>

      {pageNumber && photosLength && (
        <GalleryInfo tag="title_3_desc">
          {pageNumber}/{photosLength}
        </GalleryInfo>
      )}
    </ResidenceGalleryHeaderContainer>
  );
};
